import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SERVER_API_URL } from '../../../app.constants';
import { TimeOutConfigModel } from '../model/time-out-config.model';

@Injectable({ providedIn: 'root' })
export class TimeOutService {

    private config: TimeOutConfigModel = {
        defaultTimeoutValue: 300000, // 5 mins
        postTimeOutValue: 300000 // 5 mins
    };

    constructor(protected http: HttpClient) {
    }

    async initialize() {
        console.warn('Initializing TimeoutService to get the config from the server');
        try {
            const response = await this.http.get<TimeOutConfigModel>(SERVER_API_URL + 'time-out-config',
                { observe: 'response' }).toPromise();
            this.config = response.body;
        } catch (error) {
            console.warn('Cannot get the time out config from the server. Using default values.');
        }
    }

    getTimeOutConfig(): TimeOutConfigModel {
        return this.config;
    }

}
